var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"opc-zsched__basic-related-tip"},[_vm._v(" "+_vm._s(_vm.$t('billing.scheduler.basic_include_tip', [_vm.getFreeUserMeetingMinutes()]))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }